// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapview-renderer h1 {
    font-size: 1rem;
}
.mapview-renderer h1 a {
    text-decoration: none;
    color: var(--graphileon-color);
}

.mapview-renderer {
    font-family: var(--graphileon-font-family);
    font-size: 1rem;
}

.gm-style {
    font-family: var(--graphileon-font-family);
}

.gm-style-mot {
    font-family: var(--graphileon-font-family);
}

.gm-style-mtc button{
    font-family: var(--graphileon-font-family) !important;
}

.mapview-renderer .search-box {
    width: 40%;
    height: 2.5rem;
    margin-top: 0.625rem;
    border-radius: 0.125rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
